const VERSION = "6.1.5";
export {
  VERSION
};
